import {useTranslation} from "react-i18next";
import React, { useEffect } from 'react';

function FilesContent({register, required, errors, file, setFile}) {
  const { t } = useTranslation();

  let view;
  let text;

  useEffect(() => {
    setFile(file);
  },[file]); // eslint-disable-line react-hooks/exhaustive-deps

  function getFileData(files){
    Array.from(files).forEach(item => {
      // let size = item.size/1000000;
      // setFile({name: item.name, size:size.toFixed(2)})
      if(item.type === "application/pdf"){
        if(item.size > 5242880){
          alert(`Fichier supérieur à 5Mo (${(item.size/1048576).toFixed(0)}Mo)`);
        }else{
          setFile([...file, item]);
        }
      }else{
        if(item.size > 240800){
          alert(`Fichier supérieur à 200KB (${(item.size/1024).toFixed(0)}KB)`);
        }else{
          setFile([...file, item]);
        }
      }

    });
  }

  function SetFileList({files}){
    return (
      <div>
        <div className="c-content_files">
          {
            files.map(c => {
              return <SetItem file={c}/>
            })
          }
        </div>
      </div>
   )
  }

  function deleteFiles({data}){
    setFile(file.filter(item => !item.name.includes(data.name)));
  }

  function SetItem({file}){
    let size = file.size/1000000;
    let data = file;
    return (
      <>
        <div className="c-file_card">
          <span className="c-file_delete" onClick={() => deleteFiles({data})}></span>
          <div className="c-file_content">
            <span className="c-file_icon"></span>
            <p className="c-file_text">{file.name}</p>
            <span className="c-file_arrow"></span>
          </div>
          <p className="c-file_size">{size.toFixed(3)} Mo</p>
        </div>
      </>
   )
  }

  if(file.length !== 0){
    view = <SetFileList files={file} />
  }else{
    view = <p>{t('aucun fichier aujouté')}</p>
  }
  return (
    <>
      <div className="c-write files">
        <div className="c-write_header">
          <span className="c-header_number">4</span>
          <p className="c-header_title">{t('Ajouter des documents')}</p>
        </div>
        <div className="c-write_content">
          <div className="c-content_wrap">
            <div className="c-content_files">
              {view}
            </div>
            <div className="c-content_import">
              <span className="c-import_icon"></span>
              <input type="file" name="fileToUpload" id="fileToUpload" accept="image/png, image/jpeg, application/pdf, image/jpg" onChange={e => getFileData(e.target.files)}/>
            </div>
            {text}
          </div>
        </div>
      </div>
    </>
  )
}


export default FilesContent
